/**
 * La CATENA di ripiego di `<CardIcon>` (I-363): quali `src` provare, in che ordine, prima di arrendersi al nome scritto.
 *
 * ═══ PERCHE' ESISTE ═══
 * [M tma-orcb 04/10 ~17:1xZ, `GET /api/v1/cr/cards/:id/icon`, stg-qbot contro qbot di produzione; rifatta da tma-orcb-27-inc
 * 17:20Z] su stg-qbot mancano le icone di Ice Wizard HERO (`26000023?form=hero` → 404), Elite Barbarians EVOLUTION
 * (`26000043?form=evolution` → 404) e di Minion Giant, tutta la carta (`26000107` → 404 anche la base); in produzione le prime due
 * ci sono, Minion Giant base pure. Le immagini BASE di Ice Wizard ed Elite Barbarians su stg ci sono (200). La cura dei dati e' di
 * QBot staging, non nostra: qui si degrada meglio.
 * Prima `<CardIcon>` faceva UN tentativo (`iconUrl ?? proxy(form)`) e al primo errore mostrava il nome: un hero senza immagine sul
 * proxy avrebbe avuto un nome scritto accanto a una base che il proxy aveva eccome. E con `iconUrl` presente che falliva non
 * provava nemmeno il proxy.
 *
 * ═══ L'ORDINE ═══
 *  1. `iconUrl` — l'asset ufficiale Supercell, scelto dal chiamante secondo la forma (`CardStrip`, `DeckGrid`), se c'e';
 *  2. il proxy di QBot per la forma chiesta;
 *  3. se la forma NON e' la base: il proxy di QBot per la BASE. L'anello (giallo/viola) resta, perche' lo decide la forma chiesta
 *     e non l'immagine che e' arrivata: l'icona e' quella della carta, l'anello dice che e' un hero o un'evoluzione;
 *  4. solo allora il nome (non e' un passo della catena: e' cio' che resta quando i passi sono finiti).
 * Ogni passo si prova UNA volta (nessun ciclo, nessuna richiesta ripetuta a ogni render): la catena e' senza doppioni.
 *
 * Pura di proposito: il costruttore del proxy e' un parametro, cosi' il modulo non legge `env` e si prova senza app.
 */

export type CardForm = 'base' | 'evolution' | 'hero';

export function cardIconChain(args: {
  id: number;
  form: CardForm;
  /** L'URL ufficiale della forma chiesta (`iconUrls.*Medium`). Vuoto o assente = nessuno: una stringa vuota e' un `src` rotto. */
  iconUrl?: string | null;
  /** `qbotCardIconUrl`: il proxy di QBot per `(id, forma)`. */
  proxy: (id: number, form: CardForm) => string;
}): string[] {
  const { id, form, iconUrl, proxy } = args;
  const passi: string[] = [];
  if (iconUrl) passi.push(iconUrl);
  passi.push(proxy(id, form));
  if (form !== 'base') passi.push(proxy(id, 'base'));
  // Senza doppioni: se due passi coincidono, il secondo sarebbe la stessa richiesta fallita una seconda volta.
  return passi.filter((src, i) => passi.indexOf(src) === i);
}
